import { rankingItems } from '@/mocks/homeData';

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
              热播榜单
            </h2>
            <p className="text-sm text-foreground-500 max-w-lg mx-auto">
              实时热播排行，看看大家都在看什么
            </p>
          </div>

          <div className="bg-background-100 rounded-2xl border border-background-200/60 overflow-hidden">
            {rankingItems.map((item, idx) => (
              <div
                key={idx}
                className={`flex items-center gap-4 px-5 py-4 ${
                  idx < rankingItems.length - 1 ? 'border-b border-background-200/50' : ''
                } hover:bg-background-50 transition-colors duration-200 cursor-pointer`}
              >
                <div
                  className={`w-8 h-8 flex items-center justify-center rounded-lg text-sm font-bold flex-shrink-0 ${
                    item.rank === 1
                      ? 'bg-accent-500 text-secondary-900'
                      : item.rank === 2
                        ? 'bg-accent-400 text-secondary-900'
                        : item.rank === 3
                          ? 'bg-accent-300 text-secondary-900'
                          : 'bg-background-200 text-foreground-500'
                  }`}
                >
                  {item.rank}
                </div>

                <div className="flex-1 min-w-0">
                  <div className="text-sm font-semibold text-foreground-900 truncate">{item.title}</div>
                  <div className="text-xs text-foreground-400">{item.category}</div>
                </div>

                <div className="flex items-center gap-1 text-sm font-semibold text-primary-600 whitespace-nowrap">
                  {item.trending === 'up' ? (
                    <i className="ri-arrow-up-fill text-accent-600 text-xs"></i>
                  ) : item.trending === 'down' ? (
                    <i className="ri-arrow-down-fill text-foreground-400 text-xs"></i>
                  ) : (
                    <i className="ri-subtract-line text-foreground-400 text-xs"></i>
                  )}
                  <span>{item.hot}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}